export default __webpack_public_path__ + "static/media/2-768x806.ea9a7964.jpg";